// Removes the trackers of withdrawn categories (cookies + localStorage)
import prestashop from 'prestashop';
import { trackers } from './categories';

const EXPIRED = 'Thu, 01 Jan 1970 00:00:00 GMT';

// Never removed, whatever the patterns declared in categories.ts
const isProtected = (name: string) =>
    name === prestashop.cookieName ||
    name === 'PHPSESSID' ||
    name.startsWith('PrestaShop-');

// "www.shop.com" => [".www.shop.com", ".shop.com"] (the TLD alone is skipped)
const parentDomains = (hostname: string) => {
    const parts = hostname.split('.');

    return parts
        .slice(0, -1)
        .map((_, index) => '.' + parts.slice(index).join('.'));
};

// A cookie can only be removed with the domain it was set on, which is unknown
// from JS: try host-only first, then the current host and each parent domain
export const deleteCookie = (name: string) => {
    if (isProtected(name)) {
        return;
    }

    document.cookie = `${name}=; expires=${EXPIRED}; path=/`;

    parentDomains(location.hostname).forEach((domain) => {
        document.cookie = `${name}=; expires=${EXPIRED}; path=/; domain=${domain}`;
    });
};

const cookieNames = () =>
    document.cookie
        .split(';')
        .map((cookie) => cookie.split('=')[0].trim())
        .filter(Boolean);

const localStorageKeys = () => {
    try {
        return Object.keys(localStorage);
    } catch {
        return [];
    }
};

const removeLocalStorageKey = (key: string) => {
    try {
        localStorage.removeItem(key);
    } catch {
        // Storage disabled or unavailable: nothing to clear
    }
};

export const clearCategories = (categories: string[]) => {
    const matches = (name: string, patterns: RegExp[]) =>
        patterns.some((pattern) => pattern.test(name));

    categories.forEach((category) => {
        const { cookies = [], localStorage = [] } = trackers[category] || {};

        cookieNames()
            .filter((name) => matches(name, cookies))
            .forEach(deleteCookie);

        localStorageKeys()
            .filter((key) => matches(key, localStorage))
            .forEach(removeLocalStorageKey);
    });
};
